import shippingObject from '@/data/ShippingObject';

export default state => {
	return Object.assign(shippingObject(), state.user.fulfilment || {});
};
